import React from "react";
import { connect } from 'react-redux';
import { isDefined } from "../../../utils";

class SurveyQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptionId: undefined,
            selectedOption: undefined,
        };
        this.onSelectOption = this.onSelectOption.bind(this);
    }

    componentDidMount() {
        const
            {
                surveyQuestion
            } = this.props;

        if (!surveyQuestion || !surveyQuestion.surveyQuestionPotentialResponses
            || !Array.isArray(surveyQuestion.surveyQuestionPotentialResponses)) {
            return;
        }
        const defaultSelectedOption = surveyQuestion.surveyQuestionPotentialResponses.find(o => o.isDefaultSelected === true);
        if (isDefined(defaultSelectedOption)) {
            this.setState({
                selectedOptionId: defaultSelectedOption.id,
                selectedOption: defaultSelectedOption
            });
        }
    }

    onSelectOption(selectedOption) {
        const
            {
                surveyQuestion,
            } = this.props;

        this.setState({ selectedOptionId: selectedOption.id, selectedOption: selectedOption });
        if (isDefined(selectedOption.onClick)) {
            selectedOption.onClick();
        }

        this.props.onSelectOption(surveyQuestion.id, surveyQuestion.maxPoints, selectedOption.id, selectedOption.pointValue,
            selectedOption.isZeroMaker, selectedOption.isNotScored);
    }

    render() {
        const
            {
                surveyQuestion,
                surveyQuestionNumberInForm,
                showScore
            } = this.props;

        if (!surveyQuestion) {
            return;
        }

        let responsesLength = 0;
        const buttons = surveyQuestion.surveyQuestionPotentialResponses ?
            surveyQuestion.surveyQuestionPotentialResponses.map(o => {
                const optionStyle = this.state.selectedOptionId === o.id
                    ? "flex survey-response selected-survey-response"
                    : "flex survey-response";
                responsesLength = responsesLength + o.value.length;
                return (<div className={optionStyle}
                    key={o.id}
                    style={{ margin: '10px' }}
                    onClick={() => this.onSelectOption(o)}>
                    {o.value}
                </div>)
            }) : undefined;



        const questionCurrentScore = isDefined(this.state.selectedOption) ? this.state.selectedOption.pointValue : 0;
        const responsesStyle = responsesLength < 50 ? "flex-container-start flex-wrap" : "";

        return (<div className="system-dashboard-jibe-border flex align-items-flex-start" style={{
            //backgroundImage: `url(${`../../../../Assets/Images/V3Design/StatsPresentationBackground2.png`})`
            boxShadow: 'box-shadow: 0px 1px 15px rgba(8, 40, 50, 0.08)',
            borderRadius: '6px'
        }}>
            {showScore &&
                <div className="align-items-center-horizontal survey-question-score-box">
                    <div className="survey-question-score">{questionCurrentScore}/{surveyQuestion.maxPoints}</div>
                    <div className="survey-question-score">Score</div>
                    <div className="survey-question-number">{surveyQuestionNumberInForm}</div>
                </div>
            }
            <div>
                <div className="survey-question-display-text">
                    {surveyQuestion.displayText}
                </div>
                <div className={responsesStyle}>
                    {buttons}
                </div>
            </div>
        </div>);
    };
}

const select = state => ({});
export default connect(select)(SurveyQuestion);

